export const clickySound = new Audio("./audio/clicky-sound.wav");
export const incorrectSound = new Audio("./audio/incorrect-sound.wav");
export const correctSound = new Audio("./audio/correct-sound.wav");
export const notificationSound = new Audio("./audio/notification-sound.wav");
